import { Controller } from "@hotwired/stimulus";
import { formatHours, nightMinutes, parseDateTime } from "../schedule_helpers";

export default class extends Controller {
  static targets = ["start", "end", "total", "night"];

  connect() {
    this.update();
  }

  update() {
    const start = parseDateTime(this.startTarget.value);
    const end = parseDateTime(this.endTarget.value);

    if (start === null || end === null || end <= start) {
      this.totalTarget.textContent = "—";
      this.nightTarget.textContent = "—";
      return;
    }

    this.totalTarget.textContent = `${formatHours(end - start)} h`;
    this.nightTarget.textContent = `${formatHours(nightMinutes(start, end))} h`;
  }
}
